<a class="link" [href]="url()" target="_blank">
    <p>Spenden mit</p>
    <img src="/de-pp-logo-200px.png">
</a>
<p>Kreditkartenzahlung ebenfalls möglich</p>
